import PropTypes from 'prop-types';
import "pages/Homepage/Hero/Hero.scss";
import Button from "components/ui/Button/Button";
import Homepage1 from "pages/Homepage/assets/homepage-01.jpg";
import Homepage2 from "pages/Homepage/assets/homepage-02.jpg";
import Homepage3 from "pages/Homepage/assets/homepage-03.jpg";
import LoginDialog from "features/authentication/components/LoginDialog";
import { useAccount } from "context/AccountContext";
import { useDialog } from "context/DialogContext";
import HTMLContainer from "components/ui/HTML/HTMLContainer";
import RequestPasswordReset from "features/authentication/components/RequestPasswordReset";

function Hero({ intro }) {
  const { showDialog } = useDialog();
  const { user } = useAccount();

  return (
    <div className={ 'hero-container wrapper--margin' }>
      <div className={ 'wrapper--fluid' }>
        <div className={ 'hero' }>
          <div className={ 'hero__intro' }>
            <h1>Welkom bij Trefpunt</h1>
            <HTMLContainer>
              { intro }
            </HTMLContainer>

            { !user &&
            <div className={ 'hero__login' }>
              <div className={ 'hero__buttons' }>
                <Button variant={ 'secondary' } onClick={ () => showDialog(<LoginDialog/>) }>
                  Inloggen
                </Button>
                <Button variant={ 'ghost-light' } onClick={ () => showDialog(<RequestPasswordReset title={ `Account aanmaken` } backButton={ false } createAccount={ true }/>) }>
                  Account aanmaken
                </Button>
              </div>

              <a href={ 'https://www.anbo-pcob.nl' } className={ 'underline' }>
                Nog geen ANBO-PCOB-lid? Lees meer op anbo-pcob.nl
              </a>
            </div>
            }
          </div>

          <div className={ 'hero__images' }>
            <img src={ Homepage1 } alt={ '' }/>
            <img src={ Homepage2 } alt={ '' }/>
          </div>

          <div className={ 'hero__large-image' }>
            <img src={ Homepage3 } alt={ '' }/>
          </div>
        </div>
      </div>
    </div>
  );
}

Hero.propTypes = {
  intro: PropTypes.string,
}

export default Hero;
